import Controller from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../BaseController';

@Controller({ fragment: 'approvals' })
export default class ApprovalsController extends BaseController {

}
